import React, { useState, useEffect, useRef } from 'react';
import { Link } from "react-router-dom";
import './Header.css';
import logo from '../assets/organiZwkOmbre.png';
import { useTheme } from "../context/ThemeContext.js";
import SnowEffect from "../effects/SnowEffect.js";
import HalloweenEffect from "../effects/HalloweenEffect.js";
import SpringEffect from "../effects/SpringEffect.js";
import NewYearEffect from "../effects/NewYearEffect.js";
import { useLanguage } from '../context/LanguageContext.js';
import { logDev } from "../utils/logger.js";


const Header = ({ onHeightChange }) => {
  const { lang, setLang } = useLanguage();
  const [showSelector, setShowSelector] = useState(false);
  const headerRef = useRef(null);
  const { theme, setTheme } = useTheme();

  // 👇 Vérifie si l’utilisateur est logué (présence d’un groupeId en storage)
  const isLoggedIn = localStorage.getItem("groupeId") || sessionStorage.getItem("groupeId");

  const handleLanguageChange = (e) => {
    setLang(e.target.value);
    setShowSelector(false);
  };

  useEffect(() => {
  if (headerRef.current && typeof onHeightChange === "function") {
    const height = headerRef.current.offsetHeight;
    onHeightChange(height);
    logDev("[Header] hauteur mesurée", height);
    }
  }, [onHeightChange]);
  
  return (
    <header className="header" ref={headerRef}>
      {/* {theme === "snow" && <SnowEffect />} */} 
      {/* {theme === "snow" && <SnowEffect />} */} 
      {/* {theme === "halloween" && <HalloweenEffect />} */} 
      {/* {theme === "spring" && <SpringEffect />}*/} 
      {/* {theme === "newyear" && <NewYearEffect />} */} 

      {/* 👇 Si logué → dashboard, sinon → accueil */}      
      <Link to={isLoggedIn ? "/dashboard" : "/"}>
        <img src={logo} className="logo" alt="logo" />
        </Link>
        
      {/* 🌍 Globe visible sur petit écran */}
      <span
        className="language-globe"
        role="button"
        title="selectLanguage"
        onClick={() => setShowSelector(!showSelector)}
      >
        🌍
      </span>

      {/* Menu déroulant conditionnel */}
      {showSelector && (
        <select
        className="language-selector mobile"
        value={lang}
        onChange={handleLanguageChange}       
        >          
          <option value="fr">🇫🇷 FR</option>
          <option value="en">🇬🇧 EN</option>
          <option value="es">🇪🇸 ES</option>
          </select>
          )}          

      {/* Menu toujours visible sur grand écran */}
      <select
      className="language-selector desktop"
      value={lang}
      onChange={handleLanguageChange}
      >      
        <option value="fr">🇫🇷 FR</option>
        <option value="en">🇬🇧 EN</option>
        <option value="es">🇪🇸 ES</option>
        </select>      
    </header>
  );
};

export default Header;
